// eslint-disable-next-line import/no-extraneous-dependencies
import VueI18n from 'vue-i18n';
import i18n from '@front-app/i18n';
import VueRouter, { Route } from 'vue-router';
import { TrappRoute } from '@front-app/store/singletons/TrappRoute';
import { routes } from './routes';
import { loginGuard } from './util/guard';

export const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
});

interface TitledMeta {
	title(i18n: VueI18n, to: Route): string;
}

gtag('config', process.env.VUE_APP_GOOGLE_ANALYTICS_ID || '', {
	send_page_view: false,
});

router.beforeEach(loginGuard);

router.afterEach((to) => {
	TrappRoute.setFromRoute(to);
	const title = to.matched.slice().map((r) => (r.meta as TitledMeta).title(i18n, to) as string).reverse().join(' - ');
	document.title = title;
	gtag('event', 'page_view', {
		page_title: title,
		page_location: to.path,
		send_to: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
	});
});
